/** Service Plan Template manifest: catalogue board, creator dialog, and Manage page for plan defaults. */
import { ActivityEntityName, EntityViewDisplay, ServicePlanTemplate, SurfaceType } from '@jms/model';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';
import { PlannedWorkCol } from '../shared/planned.work.board.columns';
import { navigateToServicePlanTemplateManage } from './services/service.plan.template.board.open';

export const servicePlanTemplateManifest = registerManifest<ServicePlanTemplate>({
  entity: ActivityEntityName.ServicePlanTemplate,
  board: {
    supportedDisplays: [EntityViewDisplay.Table],
    defaults: {
      header: {
        title: 'Service Plan Templates',
        showSearch: true,
        showPaginator: true,
      },
      itemInteraction: {
        navigate: navigateToServicePlanTemplateManage,
      },
      table: {
        fillerColumn: true,
        columns: {
          byField: {
            name: PlannedWorkCol.title,
            description: PlannedWorkCol.description,
            updatedAt: PlannedWorkCol.updated,
          },
        },
      },
    },
  },
  routes: {
    root: '/crm/service-plan-templates',
  },
  surfaces: {
    [SurfaceType.Creator]: () => import('./surface/creator/service.plan.template.creator.surface').then(module => module.servicePlanTemplateCreatorSurface),
    [SurfaceType.Manage]: () => import('./surface/manage/service.plan.template.manage.surface').then(module => module.servicePlanTemplateManageSurface),
  },
  operations: {
    create: { surface: SurfaceType.Creator, navigateOnCreate: true, presentation: { mode: 'dialog', width: 'min(640px, calc(100vw - 40px))', height: 'min(540px, calc(100vh - 48px))', maxHeight: 'calc(100vh - 48px)' } },
    edit: { surface: SurfaceType.Manage },
  },
  relations: {
    [ActivityEntityName.ServiceLineTemplate]: () => import('./relations/service.plan.template.outline.relation').then(module => module.servicePlanTemplateOutlineBoardBuilder),
  },
});
